import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../Button/Button'


const HeaderItem = ({ data }) => {

    const { id, tags, name, link, head } = data

    const pathname = window.location.pathname
    return (
        <Carosol key={{ id }} style={{
            background: `url(${pathname === '/' ? "/images/back.jpg" : `/images/${id}.jpg`})`,
            backgroundPosition: "center",
            backgroundSize: "cover"
        }}>
            <Overlay>
                <span>{tags}</span>
                <h1>{head}</h1>
                <h1>{name}</h1>
            </Overlay>
            <Box>
                <div>
                    <a href="https://github.com/mukulrajpoot262610">
                        <Button text="Github" icon="github-square" />
                    </a>
                    {
                        pathname === "/" ? (<Link to={`/projects/${id}`}>
                            <Button text={name} icon="link" />
                        </Link>) : (<a href={link}>
                            <Button text="Go to Project" icon="link" />
                        </a>)
                    }
                </div>
                <h1>Made with ❤ by Mukul Rajpoot</h1>
            </Box>
        </Carosol>
    )
}

const Carosol = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;
`;

const Box = styled.section`
    position: absolute;
    width: 75%;
    height: 10vh;
    left: 0%;
    bottom: 0%;
    background: white;
    z-index: 100;
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    padding: 0 5rem;

    & > div {
        display: flex;
    }

    & > a {
        display: flex;
        text-decoration: none;
        color: black;
    }

    @media (max-width: 768px){
        padding: 0 1rem;
        width: 100%;
        padding: 0 2rem;
    }

    & > h1 {
        font-size: 1.5rem;
    }
    `

const Overlay = styled.div`
    height: 100%;
    width: 100%;
    position: absolute;
    padding: 0 15rem;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background: rgba(0,0,0,0.4);
    backdrop-filter: blur(.5rem);
    color: #fff;
    font-size: 2rem;

    @media (max-width: 768px) {
        padding: 0 5rem;
    }

    & > h1 {
        font-size: 4rem;
        color: #fff;
        max-width: 50%;
        text-transform: capitalize;
        margin-bottom: 4rem;

        @media (max-width: 768px) {
            max-width: 100%;
            font-size: 2rem;
        }
    }
`

export default HeaderItem
